// extracted by mini-css-extract-plugin
module.exports = {"outer":"wgZAa","textContainer":"_1jINz","heading":"hwMhm","knowMore":"_1rDXD"};